import { IRouteKeyData } from 'src/app/infrastructure/services/route-service/models/route-key-data';
import { ITabPageStorage, TabPageStorage } from '../../storage/models/tab-page-storage';
import { IPageData } from 'src/app/infrastructure/services/page-services/models/page-data';
import { TRoutePage } from 'src/app/infrastructure/services/route-service/models/route-page';

// Eén bezoek aan één pagina. Het frame draagt zowel de identiteit (welke pagina, welke url) als de
// state die bij dát bezoek hoort: gekozen tab, tabhoogte en per-lijst scroll/filter. Omdat de state
// in het frame woont en niet onder een pagina-sleutel, levert opnieuw afdalen vanzelf een schone
// pagina op — er is geen wis-actie die op het juiste moment moet vuren.
export interface INavFrame extends ITabPageStorage {
    id: string;
    routePage: TRoutePage | null;
    routePath: string;
    routeKeys: IRouteKeyData | null;
    displayName: string | null;
}

export interface INavStackTree {
    order: string[];                        // frame-ids, onder → boven
    frames: Record<string, INavFrame>;
    sequence: number;                       // teller voor nieuwe frame-ids
}

export function navFrame_create(id: string, pageData: IPageData, routePath: string): INavFrame {
    return {
        ...new TabPageStorage(),
        id,
        routePage: pageData?.routePage ?? null,
        routePath,
        routeKeys: pageData?.routeKeyData ?? null,
        displayName: pageData?.displayName ?? null,
    };
}
